module.exports = __webpack_public_path__ + "static/media/ppg1.e64b1072.jpg";